import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { j as transformToVersionedTag } from './utils.js';
import { d as defineCustomElement$6 } from './wpp-icon-error2.js';
import { d as defineCustomElement$5 } from './wpp-icon-warning2.js';
import { d as defineCustomElement$4 } from './wpp-internal-label2.js';
import { d as defineCustomElement$3 } from './wpp-internal-tooltip2.js';
import { d as defineCustomElement$2 } from './wpp-tooltip2.js';
import { d as defineCustomElement$1 } from './wpp-typography2.js';

const wppLabelCss = ".sc-wpp-label-h{display:-ms-flexbox;display:flex}.sc-wpp-label-h .internal-label-wrapper.sc-wpp-label{display:-ms-flexbox;display:flex}";

const WppLabel = /*@__PURE__*/ proxyCustomElement(class WppLabel extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.hostCssClasses = () => ({
      'wpp-label': true,
    });
    this.description = undefined;
    this.htmlFor = undefined;
    this.optional = false;
    this.typography = 's-strong';
    this.disabled = false;
    this.config = undefined;
    this.tooltipConfig = {
      popperOptions: { strategy: 'fixed' },
    };
  }
  render() {
    return (h(Host, { class: this.hostCssClasses(), exportparts: "wrapper, content, icon" }, h("label", { class: "internal-label-wrapper", htmlFor: this.htmlFor, part: "wrapper" }, h("wpp-internal-label-v2-22-2", { labelText: this.config?.text, description: this.config?.description, optional: this.optional, typography: this.typography, disabled: this.disabled, locales: this.config?.locales, tooltipConfig: this.tooltipConfig, part: "content" }, this.config?.icon && h(transformToVersionedTag(this.config?.icon), { slot: 'icon', part: 'icon' })))));
  }
  static get registryIs() { return "wpp-label-v2-22-2"; }
  static get style() { return wppLabelCss; }
}, [2, "wpp-label", "wpp-label-v2-22-2", {
    "description": [1],
    "htmlFor": [1, "html-for"],
    "optional": [4],
    "typography": [1],
    "disabled": [516],
    "config": [1040],
    "tooltipConfig": [16]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-label-v2-22-2", "wpp-icon-error-v2-22-2", "wpp-icon-warning-v2-22-2", "wpp-internal-label-v2-22-2", "wpp-internal-tooltip-v2-22-2", "wpp-tooltip-v2-22-2", "wpp-typography-v2-22-2"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-label-v2-22-2":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppLabel);
      }
      break;
    case "wpp-icon-error-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "wpp-icon-warning-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "wpp-internal-label-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "wpp-internal-tooltip-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "wpp-tooltip-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
    case "wpp-typography-v2-22-2":
      if (!customElements.get(tagName)) {
        defineCustomElement$1();
      }
      break;
  } });
}

export { WppLabel as W, defineCustomElement as d };
